var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaDrogerie2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ab6537;}.cls-3{fill:#5a4146;}.cls-4{fill:#87ced9;}.cls-5{fill:#dbdbd9;}.cls-6{fill:#d1d1cf;}.cls-7{fill:#4398d1;}.cls-8{fill:#a2dfe8;}.cls-9{fill:#82bae0;}.cls-10{fill:#f0b7b4;}.cls-11{fill:#ccccca;}.cls-12{fill:#f2c7c4;}.cls-13{fill:#71c4d1;}.cls-14{fill:#388bc2;}.cls-15{fill:#edb0ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8,
    y: 129.66,
    width: 144,
    height: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.69,
    y: 129.66,
    width: 27.31,
    height: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.45,
    y: 70.07,
    width: 29.79,
    height: 59.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 15.45,
    y: 50.21,
    width: 29.79,
    height: 19.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 35.31,
    y: 50.21,
    width: 9.93,
    height: 19.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 55.17,
    y: 70.07,
    width: 29.79,
    height: 59.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.17,
    y: 50.21,
    width: 29.79,
    height: 19.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 75.03,
    y: 50.21,
    width: 9.93,
    height: 19.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 22.9,
    y: 77.52,
    width: 4.97,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 22.9,
    y: 87.45,
    width: 4.97,
    height: 12.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 62.62,
    y: 77.52,
    width: 4.97,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 62.62,
    y: 87.45,
    width: 4.97,
    height: 12.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M144.55,104.83H99.86L92.41,25.38H152Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 99.86,
    y: 104.83,
    width: 44.69,
    height: 24.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 99.86,
    y: 117.24,
    width: 44.69,
    height: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M129.66,122.21h-14.9a2.48,2.48,0,0,1-2.48-2.49v-2.48a5,5,0,0,1,5-5h9.93a5,5,0,0,1,5,5v2.48a2.48,2.48,0,0,1-2.48,2.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 92.41,
    y: 15.45,
    width: 59.59,
    height: 9.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.87,45.49l4.94-.5,1.49,14.9-4.94.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M99.88,35.56l4.94-.5.49,5-4.94.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 15.45,
    y: 70.07,
    width: 29.79,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 55.17,
    y: 70.07,
    width: 29.79,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.62,
    y: 117.24,
    width: 14.9,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 22.9,
    y: 117.24,
    width: 14.9,
    height: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M99.07,96.41l.79,8.42h44.69L152,25.38h-2.91a124.34,124.34,0,0,1-50,71Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaDrogerie2);
export default __webpack_public_path__ + "static/media/ka_drogerie2.81492b02ace352b094655810be64442e.svg";
export { ForwardRef as ReactComponent };